export default __webpack_public_path__ + "static/media/tour-img2.d86f0ad1.jpg";